import React from 'react';
import { Grid, Skeleton } from 'drift-ui';

const SkeletonLoader = () => {
  return (
    <Grid
      container
      rowSpacing={2}
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        padding: '.5em',
      }}
    >
      <Skeleton variant="rectangular" width="976px" height="5vh" />
      <Skeleton variant="rectangular" width="976px" height="5vh" />
      <Skeleton variant="rectangular" width="976px" height="30vh" />
      <Skeleton variant="rectangular" width="976px" height="12vh" />
      <Skeleton variant="rectangular" width="976px" height="14vh" />
    </Grid>
  );
};

export default SkeletonLoader;
